import React from 'react';

const YearsOfTrainingField = ({ value = "", onChange, required = false }) => {
  const years = Array.from({ length: 21 }, (_, i) => i);
  
  return (
    <div className="half">
      <label htmlFor="years_of_training">Years of Training</label>
      <select
        id="years_of_training"
        name="years_of_training"
        className="field"
        onChange={onChange}
        value={value}
        required={required}
        aria-label="Years of Training"
      >
        <option value="" disabled>Select Years of Training</option>
        {years.map(year => (
          <option key={year} value={year}>
            {`${year} ${year === 1 ? 'year' : 'years'}`}
          </option>
        ))}
      </select>
    </div>
  );
};

export default YearsOfTrainingField;